import React from 'react';

import { DefaultComponentProps, PartnerList, PartnerInfo } from '../../types';

interface Props extends DefaultComponentProps {
  partnerList: PartnerList;
  partnerInfo: PartnerInfo;
  handlePartnerChanged: (option: React.SyntheticEvent<HTMLSelectElement>) => void;
  showValidationError: boolean;
}

export const PartnerSelect = ({ textConfig, partnerList, partnerInfo, showValidationError, handlePartnerChanged }: Props) => {
  const { label, defaultOptionText, validationMessage } = textConfig.partnerSelect;
  const renderValidationFeeback = () => {
    return showValidationError ? <div className="form__field__feedback__text">{validationMessage}</div> : null;
  };

  return (
    <div className="form__field">
      <label htmlFor="partner" className="form__field__label">
        {label}
      </label>
      <select
        onChange={handlePartnerChanged}
        id="partner"
        className="form__field__select"
        aria-describedby="partnerFeedback"
        aria-invalid={showValidationError}
        value={partnerInfo.partnerNumber}>
        <option value="">{defaultOptionText}</option>
        {partnerList.map(({ partnerId, name }) => {
          return (
            <option key={partnerId} value={partnerId}>
              {name}
            </option>
          );
        })}
      </select>
      <div className="form__field__feedback" id="partnerFeedback">
        {renderValidationFeeback()}
      </div>
    </div>
  );
};
